import { user } from "@/services/requests";
import { AxiosError } from "axios";
import { useRouter } from "next/router";
import { destroyCookie, parseCookies, setCookie } from "nookies";
import { useMutation } from "react-query";

interface Props {
  setIsPassword?: (val: boolean) => void;
}

function useUserRegister({ setIsPassword }: Props) {
  const { push } = useRouter();

  const { locale_path } = parseCookies();

  const {
    mutate: postRegister,
    isLoading,
    error,
    isSuccess,
  } = useMutation((params: { phone: string }) => user.postRegister(params));

  const {
    mutate: postVerifyPhone,
    isLoading: isLoadingVerify,
    error: errorVerify,
    isSuccess: isSuccessVerify,
  } = useMutation(
    (params: { phone: string; code: string }) => user.postVerifyPhone(params),
    {
      onSuccess: () => {
        if (setIsPassword) {
          setIsPassword(true);
        }
      },
    }
  );

  const {
    mutate: postSetPassword,
    isLoading: isLoadingPassword,
    error: errorPassword,
  } = useMutation(
    (params: {
      phone: string;
      code: string;
      password: string;
      uuid: string | null;
    }) => user.postSetPassword(params),
    {
      onSuccess: (data) => {
        setCookie(null, "auth", data.data.access_token, {
          maxAge: 30 * 24 * 60 * 60,
          path: `/`,
        });
        push({
          pathname: `/${locale_path}`,
        });
        destroyCookie(null, "uuid", { path: "/" });
      },
    }
  );

  return {
    postRegister,
    isLoading,
    isSuccess,
    error: error,
    postVerifyPhone,
    isLoadingVerify,
    isSuccessVerify,
    errorVerify,
    postSetPassword,
    isLoadingPassword,
    errorPassword,
  };
}

export default useUserRegister;
